import { Science } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import BuildIcon from "@mui/icons-material/Build";
import CategoryIcon from "@mui/icons-material/Category";
import EnergySavingsLeafIcon from "@mui/icons-material/EnergySavingsLeaf";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FactoryIcon from "@mui/icons-material/Factory";
import HistoryIcon from "@mui/icons-material/History";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import ShareIcon from "@mui/icons-material/Share";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ShieldIcon from "@mui/icons-material/Shield";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from "@mui/material";
import MDButton from "components/MDButton";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getSubModulesByRoleId } from "store";
import Cookies from "universal-cookie";

import { QRCodeCanvas } from "qrcode.react";
import Config from "../../config/index";

// Import exact desktop components so rendering stays byte-identical
import JourneyTimeline from "./journeyTimeline";
import Operations from "./operations";
import RepairRecycleModal from "./RepairInfo";
import { getAllDataForDpp, } from "../../store";
import QRCodeModal from "./QRCodeModal";
import MiniLogo from "assets/mini-logo.png";

const cookies = new Cookies();

const readOp = (op = {}) => ({
  name: op.operationName || op.operation || op.name || op.processName || op.stageName || "",
  person: op.operatorName || op.operator || op.personName || op.responsiblePerson || op.supervisor || op.person || "",
  plantCode: op.plantCode || op.plant_code || op.plant || "",
  plantLocation: op.plantLocation || op.plant_location || op.location || "",
});

const OperationsTimeline = ({ operationsData }) => {
  const list = Array.isArray(operationsData) ? operationsData : [];
  const canResolve = list.length > 0 && list.some((op) => readOp(op).name);

  if (!canResolve) {
    return <Operations operationsData={operationsData} />;
  }

  return (
    <div className="mobile-ops-timeline">
      {list.map((op, i) => {
        const o = readOp(op);
        const isLast = i === list.length - 1;
        return (
          <div key={i} className={`mobile-ops-item ${isLast ? "is-last" : ""}`}>
            {!isLast && <span className="mobile-ops-line" />}
            <span className="mobile-ops-dot" />
            <div className="mobile-ops-card">
              <div className="mobile-ops-title">
                {o.name}
                {o.person && <span className="mobile-ops-person"> ({o.person})</span>}
              </div>
              <div className="mobile-ops-row">
                <span className="mobile-ops-key">Plant Code:</span>
                <span className="mobile-ops-val">{o.plantCode || "—"}</span>
              </div>
              <div className="mobile-ops-row">
                <span className="mobile-ops-key">Plant Location:</span>
                <span className="mobile-ops-val">{o.plantLocation || "—"}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};




const HierarchyNode = ({ node, isRoot, handleRedirect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const hasDpp = isRoot ? true : !!node.childDpp;

  const displayCode = isRoot
    ? (node.dppCode || node.itemCode)
    : (node.childDpp ? node.childDpp.dppCode : node.itemCode);

  const displayId = isRoot
    ? node.dppId
    : (node.childDpp ? node.childDpp.dppId : null);

  const externalUrl = isRoot
    ? (node.url || null)
    : (node.childDpp ? node.childDpp.url : node.url);

  const childArray = isRoot
    ? node.children
    : (node.childDpp ? node.childDpp.children : []);

  const isExpandable = childArray && childArray.length > 0;

  return (
    <div style={{ marginTop: "8px", width: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px 12px",
          background: hasDpp ? "#ffffff" : "#f8fafc",
          border: "1px solid",
          borderColor: hasDpp ? "#e2e8f0" : "#eef2ff",
          borderRadius: "8px",
          cursor: isExpandable ? "pointer" : "default",
          boxShadow: hasDpp ? "0 2px 4px rgba(0,0,0,0.02)" : "none"
        }}
        onClick={() => {
          if (isExpandable) setIsOpen(!isOpen);
        }}
      >
        <div style={{ width: "20px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          {isExpandable && (
            <ExpandMoreIcon
              style={{
                fontSize: "20px", color: "#64748b",
                transform: isOpen ? "rotate(0deg)" : "rotate(-90deg)",
                transition: "transform 0.2s ease"
              }}
            />
          )}
        </div>

        <div style={{ flex: 1, fontSize: "14px", wordBreak: "break-all", display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
          {isRoot ? (
            <span style={{ fontWeight: 700, color: "#0f172a" }}>
              {displayCode}
            </span>
          ) : hasDpp && displayId ? (
            handleRedirect ? (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  handleRedirect(e, displayId, displayCode);
                }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "4px 12px",
                  background: "#eff6ff",
                  color: "#2563eb",
                  border: "1px solid #bfdbfe",
                  borderRadius: "6px",
                  fontSize: "13px",
                  fontWeight: 700,
                  cursor: "pointer",
                  textDecoration: "underline",
                  textUnderlineOffset: "3px",
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#dbeafe";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#eff6ff";
                }}
              >
                {displayCode}
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            ) : (
              <span style={{ fontWeight: 600, color: "#0f172a" }}>
                {displayCode}
              </span>
            )
          ) : (
            <span style={{ fontWeight: 500, color: "#94a3b8", display: "flex", alignItems: "center" }}>
              {displayCode}
              {/* <span style={{ fontSize: "11px", fontWeight: 600, background: "#e2e8f0", color: "#64748b", padding: "2px 6px", borderRadius: "4px", marginLeft: "6px" }}>
                (No DPP)
              </span> */}
            </span>
          )}


          {externalUrl && handleRedirect && (
            <MDButton
              color="info"
              variant="outlined"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                let url = externalUrl;
                if (!/^https?:\/\//i.test(url)) {
                  url = 'http://' + url;
                }
                window.open(url, "_blank", "noopener,noreferrer");
              }}
              sx={{
                padding: "4px 10px",
                fontSize: "12px",
                minHeight: "28px",
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: "6px"
              }}
            >
              View DPP
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </MDButton>
          )}
        </div>
      </div>

      {isOpen && isExpandable && (
        <div style={{ paddingLeft: "10px", marginLeft: "18px", borderLeft: "1.5px dashed #cbd5e1", marginTop: "4px" }}>
          {childArray.map((child, idx) => (
            <HierarchyNode key={idx} node={child} isRoot={false} handleRedirect={handleRedirect} />
          ))}
        </div>
      )}
    </div>
  );
};

const DppMobileView = ({
  mainData,
  treeMapData,
  getAllDataForDpp,
  productImage,
  dppId,
  hasIndustryId,
  hasBatteryIndustry,
  hasSteelIndustry,
  loadDppSidebarSection,
  fetchDppSectionService,
  baseUrl,
  roleName,
  jwtToken,
  handleDocumentClick,
  productsListForDppOptions = [],
  getSubModulesByRoleIdReducer,
  getSubModulesByRoleId,
  downloadReport = true,
}) => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(search);
  const urlDppId = queryParams.get("dppId") || queryParams.get("dppid");
  const urlDppCode = queryParams.get("dppCode") || queryParams.get("dppcode");

  const hasDppId = Boolean(urlDppId || urlDppCode);
  const isFromQRCode = pathname.toLowerCase() === "/dpp" && hasDppId;

  const loginDetails = cookies.get("loginDetailsForWMS");
  const roleId = loginDetails?.data?.roleId;

  const [showQR, setShowQR] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);

  const handleTreeRedirect = (e, targetDppId, targetDppCode) => {
    if (!targetDppId) return;

    const matchedOption = productsListForDppOptions?.find(
      (item) => item.value === targetDppId
    );

    const finalCode = matchedOption ? matchedOption.value : targetDppId;
    const finalLabel = matchedOption ? matchedOption.label : targetDppCode;

    const routeToEncode = `/dpp?dppCode=${finalLabel || ""}`;
    const encodedPath = btoa(routeToEncode);

    const url = `${encodedPath}`;
    window.open(url, "_blank", "noopener,noreferrer");


  };



  const handleViewMoreInfo = () => {
    try {
      let targetUrl = "";

      if (pathname.toLowerCase().startsWith("/dpp")) {
        targetUrl = pathname + search;
      } else {
        const encodedString = pathname.substring(1);
        targetUrl = atob(encodedString);
      }

      localStorage.setItem("dppRedirectUrl", targetUrl);
      navigate('/login');

    } catch (error) {
      console.error("URL redirect fail ho gaya:", error);
      navigate('/login');
    }
  };

  const headerRef = useRef(null);
  const imgBoxRef = useRef(null);
  const imgInnerRef = useRef(null);
  const logoBoxRef = useRef(null);
  const isReady = !!mainData && Object.keys(mainData).length > 0;
  const dppCode = mainData?.mainCard?.productDetails?.dppCode;




  const routeToEncode = `/dpp?dppCode=${dppCode || ""}`;
  const encodedPath = btoa(routeToEncode);


  const effectiveBaseUrl = baseUrl || Config?.baseUrl || "";

  const handleDownload = async (isExcel = 1) => {
    try {
      const response = await fetch(
        `${effectiveBaseUrl}/dpp/get_report?roleId=${roleId}&dppCode=${dppCode}&isExcel=${isExcel}`
      );

      if (!response.ok) {
        throw new Error("Failed to download report");
      }


      const result = await response.json();

      if (!result?.data?.base64) {
        throw new Error("Invalid response");
      }

      const base64 = result.data.base64;

      // Decode Base64
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      // Create Blob
      const blob = new Blob([byteArray], {
        type: isExcel
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "application/json",
      });

      // Download
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = isExcel
        ? "DPP_Report.xlsx"
        : `DPP_Report${dppCode || ""}.json`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  // const downloadQRCode = () => {
  //   const canvas = document.getElementById("mobile-qr-canvas") || document.getElementById("qr-canvas");
  //   if (canvas) {
  //     const pngUrl = canvas
  //       .toDataURL("image/png")
  //       .replace("image/png", "image/octet-stream");

  //     let downloadLink = document.createElement("a");
  //     downloadLink.href = pngUrl;
  //     downloadLink.download = `DPP_QR_${dppCode || ""}.png`;
  //     document.body.appendChild(downloadLink);
  //     downloadLink.click();
  //     document.body.removeChild(downloadLink);
  //   }
  // };


  const downloadQRCode = () => {
    const qrCanvas = document.getElementById("mobile-qr-canvas") || document.getElementById("qr-canvas");
    if (!qrCanvas) return;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const width = 600;
    const height = 800;
    canvas.width = width;
    canvas.height = height;

    const drawRoundRect = (x, y, w, h, r) => {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.lineTo(x + w - r, y);
      ctx.quadraticCurveTo(x + w, y, x + w, y + r);
      ctx.lineTo(x + w, y + h - r);
      ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      ctx.lineTo(x + r, y + h);
      ctx.quadraticCurveTo(x, y + h, x, y + h - r);
      ctx.lineTo(x, y + r);
      ctx.quadraticCurveTo(x, y, x + r, y);
      ctx.closePath();
    };

    ctx.fillStyle = "#f1f5f9";
    ctx.fillRect(0, 0, width, height);

    const cardX = 40;
    const cardY = 40;
    const cardW = width - 80;
    const cardH = height - 80;
    const cornerRadius = 24;

    ctx.shadowColor = "rgba(0, 0, 0, 0.15)";
    ctx.shadowBlur = 40;
    ctx.shadowOffsetY = 15;

    drawRoundRect(cardX, cardY, cardW, cardH, cornerRadius);
    ctx.fillStyle = "#ffffff";
    ctx.fill();

    ctx.shadowColor = "transparent";
    ctx.shadowBlur = 0;
    ctx.shadowOffsetY = 0;

    ctx.save();
    drawRoundRect(cardX, cardY, cardW, cardH, cornerRadius);
    ctx.clip();

    const headerHeight = 170;
    const gradient = ctx.createLinearGradient(cardX, cardY, cardX + cardW, cardY + headerHeight);
    gradient.addColorStop(0, "#0f172a");
    gradient.addColorStop(1, "#0db26b");

    ctx.fillStyle = gradient;
    ctx.fillRect(cardX, cardY, cardW, headerHeight);

    ctx.fillStyle = "#fbbf24";
    ctx.fillRect(cardX, cardY + headerHeight - 4, cardW, 4);

    ctx.fillStyle = "#ffffff";
    ctx.font = "bold 26px Inter, system-ui, sans-serif";
    ctx.textAlign = "center";
    ctx.letterSpacing = "2px";
    ctx.fillText("DIGITAL PRODUCT PASSPORT", width / 2, cardY + 75);

    ctx.fillStyle = "rgba(255, 255, 255, 0.85)";
    ctx.font = "500 16px Inter, system-ui, sans-serif";
    ctx.fillText("Secure & Verified Product Journey", width / 2, cardY + 115);

    ctx.restore();

    const qrSize = 300;
    const qrX = (width - qrSize) / 2;
    const qrY = cardY + headerHeight + 70;

    ctx.shadowColor = "rgba(0, 0, 0, 0.08)";
    ctx.shadowBlur = 20;
    ctx.shadowOffsetY = 10;
    drawRoundRect(qrX - 25, qrY - 25, qrSize + 50, qrSize + 50, 16);
    ctx.fillStyle = "#ffffff";
    ctx.fill();

    ctx.shadowColor = "transparent";
    ctx.strokeStyle = "#f1f5f9";
    ctx.lineWidth = 2;
    ctx.stroke();

    ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);

    ctx.fillStyle = "#475569";
    ctx.font = "17px Inter, system-ui, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText("Scan to access complete lifecycle &", width / 2, qrY + qrSize + 85);
    ctx.fillText("authenticity details of this product.", width / 2, qrY + qrSize + 115);

    ctx.fillStyle = "#cbd5e1";
    ctx.font = "bold 13px Inter, system-ui, sans-serif";
    ctx.letterSpacing = "1px";
    ctx.fillText("POWERED BY MOBILLOR", width / 2, cardY + cardH - 35);

    const pngUrl = canvas.toDataURL("image/png");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;

    downloadLink.download = `DPP_QR_${dppCode || "Card"}.png`;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  useEffect(() => {
    if (typeof getSubModulesByRoleId === "function") {
      getSubModulesByRoleId(roleId, jwtToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);
  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer?.subModulesByRoleData?.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (imgBoxRef.current && !imgBoxRef.current.contains(event.target)) {
        setShowDownloadMenu(false);
      }
    };

    if (showDownloadMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDownloadMenu]);

  const tabsRef = useRef(null);
  const [tabsThumb, setTabsThumb] = useState({ width: 100, left: 0 });

  const updateTabsThumb = () => {
    const el = tabsRef.current;
    if (!el || !el.scrollWidth) return;
    setTabsThumb({
      width: Math.min(100, (el.clientWidth / el.scrollWidth) * 100),
      left: (el.scrollLeft / el.scrollWidth) * 100,
    });
  };

  useEffect(() => {
    if (!isReady) return undefined;
    const t = setTimeout(updateTabsThumb, 0);
    window.addEventListener("resize", updateTabsThumb);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", updateTabsThumb);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady, modulesData]);

  const hasModuleAction = (moduleUuid, actionUuid) => {
    // if (isFromQRCode && !roleId) return true;
    const found = modulesData?.find((m) => m.moduleId === moduleUuid);
    return found ? found.actionId.includes(actionUuid) : null;
  };

  const viewManufacturing = hasModuleAction("d51e5caa-b714-4739-877a-3b78d6f9d263", "6fd9218e-53e3-49ec-85bc-ef986f9ede86");
  const viewRm = hasModuleAction("852fd581-2cd9-40d1-b0f6-e29dd61566ff", "94e1aedf-8637-4d27-9079-2812f320e458");
  const viewProductTesting = hasModuleAction("16cc0217-cbce-4e3f-874b-89b3fbdd0232", "896c7b19-7fe5-4306-9f06-2735e57a7b84");
  const viewValidation = hasModuleAction("b3605909-30dc-4c9f-8918-f1ef34354fd2", "acf6e194-8a3f-4c7f-98b7-9cc2151ed763");
  const viewCoc = hasModuleAction("269b317f-3fc3-4ce8-b885-0817acf36a66", "1f130e9a-11bf-4ad3-b690-4fcefedfbb44");
  const viewDurability = hasModuleAction("5e690abe-d7a1-4e45-8782-43409b4edab2", "24059d11-ee70-4a0d-a132-56bf7195de49");
  const viewRepairValue = hasModuleAction("9f3b7cf0-eb97-4567-8d4a-711868269662", "a0f6b96e-282c-4349-b655-f08f172739f8");
  const viewPackaging = hasModuleAction("7e02c688-4e21-4805-9f51-2320dda92382", "825e65a6-0f01-4fe7-91a1-63cb571b093a");
  const viewUsageHistory = hasModuleAction("efdda63c-9aed-4cef-8fab-8a4bfb09c4f4", "f5bbfe82-821f-4980-a9cc-cb63a8e141ff");
  const viewSocialCompliance = hasModuleAction("013a3276-d1db-4051-b489-b199b4710cf4", "3dce3a16-274c-4937-92cc-df13fa7c6c8d");

  const [selectedJourneyKey, setSelectedJourneyKey] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mobileActiveStep, setMobileActiveStep] = useState(null);
  const [itemsDataForRM, setItemsDataForRM] = useState([]);
  const [techSectionData, setTechSectionData] = useState(null);

  const [openSections, setOpenSections] = useState({
    operations: false,
    detailedInfo: false,
    careInstructions: true,
    materialsUsed: true,
    productTestTypes: true,
    chemicalAnalysis: true,
    rawMaterialsDetails: true,
    journeyTimeline: true,
    repairRecycle: true,
  });
  const toggleSection = (key) =>
    setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));

  const [openMaterialModal, setOpenMaterialModal] = useState(false);
  const [selectedMaterialData, setSelectedMaterialData] = useState(null);
  const [openViewItemsModal, setOpenViewItemsModal] = useState(false);
  const [viewItemsData, setViewItemsData] = useState(null);
  const [testType, setTestType] = useState("");

  const openTestModal = (data, type) => {
    setViewItemsData(data);
    setTestType(type);
    setOpenViewItemsModal(true);
  };

  const handleViewClick = (dppCode) => {
    if (!dppCode) return;

    const matchedOption = productsListForDppOptions?.find(
      (item) => item.value === dppCode,
    );
    const targetCode = matchedOption ? matchedOption.value : dppCode;
    const targetLabel = matchedOption ? matchedOption.label : dppCode;

    const routeToEncode = `/dpp?dppCode=${targetLabel || targetCode}`;
    const encodedPath = btoa(routeToEncode);

    const url = `${encodedPath}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };



  const journeySteps = [
    { key: "manufacturer", route: "manufacturing", view: viewManufacturing, icon: Inventory2Icon, color: "#FF5F15" },
    { key: "rmTraceability", route: "raw_material", view: viewRm, icon: CategoryIcon, color: "#0000FF" },
    { key: "productTests", route: "product_testing", view: viewProductTesting, icon: Science, color: "black" },
    { key: "technicalDocuments", route: "technical_documents_bydpp", view: viewValidation, icon: ArticleIcon, color: "#F59E0B" },
    { key: "chainOfCustody", route: "coc", view: viewCoc, icon: LocalShippingIcon, color: null },
    { key: "durabilityAndLifespan", route: "durability_bydpp", view: viewDurability, icon: ShieldIcon, color: "#A78BFA" },
    { key: "returnRepairInfo", route: "repair_recycle_value", view: viewRepairValue, icon: BuildIcon, color: "#60A5FA" },
    { key: "packagingWasteManagement", route: "packaging_waste_management", view: viewPackaging, icon: FactoryIcon, color: "#FF69B4" },
    { key: "productUsageHistory", route: "product_usage_history", view: viewUsageHistory, icon: HistoryIcon, color: "#9C27B0" },
    { key: "socialCompliance", route: "environmental", view: viewSocialCompliance, icon: EnergySavingsLeafIcon, color: null },
  ];

  const formatFloat = (value, decimals = 2) => {
    if (value === null || value === undefined || value === "") return "—";
    if (typeof value === "number") return value.toFixed(decimals);
    if (typeof value === "string") {
      const num = parseFloat(value);
      return isNaN(num) ? value : num.toFixed(decimals);
    }
    return String(value);
  };

  const fetchSectionData = async (route, preferService = false) => {
    if (!preferService && typeof loadDppSidebarSection === "function") {
      return (await loadDppSidebarSection(route)) || null;
    }
    if (typeof fetchDppSectionService === "function") {
      const res = await fetchDppSectionService({ baseUrl, roleName, route, dppId, jwtToken });
      return res?.data || null;
    }
    return null;
  };

  const requestIdRef = useRef(0);

  const openJourneyStep = async (step) => {
    if (!dppId || !step) return;
    const reqId = ++requestIdRef.current;
    setSelectedJourneyKey(step.key);
    setMobileActiveStep(null);
    setItemsDataForRM([]);
    setTechSectionData(null);
    setLoading(true);

    const techDocsPromise =
      step.key === "technicalDocuments"
        ? Promise.resolve(null)
        : fetchSectionData("technical_documents_bydpp", true).catch((err) => {
          console.error("Error fetching technical documents:", err);
          return null;
        });

    try {
      if (step.key === "rmTraceability") {
        const [rawData, rmTraceData] = await Promise.all([
          fetchDppSectionService({ baseUrl, roleName, route: "raw_material", dppId, jwtToken }),
          fetchDppSectionService({
            baseUrl,
            roleName,
            route: "dpp_id_for_item_details",
            dppId,
            jwtToken,
            basePath: "/dpp/rm_traceability",
          }),
        ]);
        if (reqId !== requestIdRef.current) return;
        setMobileActiveStep(rawData?.data || null);
        setItemsDataForRM(rmTraceData?.data || []);
      } else {
        const data = await fetchSectionData(step.route);
        if (reqId !== requestIdRef.current) return;
        setMobileActiveStep(data || null);
      }
      const docsData = await techDocsPromise;
      if (reqId !== requestIdRef.current) return;
      setTechSectionData(docsData || null);
    } catch (err) {
      if (reqId !== requestIdRef.current) return;
      console.error("Error fetching stage data for mobile view:", err);
      setMobileActiveStep(null);
    } finally {
      if (reqId === requestIdRef.current) setLoading(false);
    }
  };

  const prevDppIdRef = useRef(dppId);
  useEffect(() => {
    if (prevDppIdRef.current === dppId) return;
    prevDppIdRef.current = dppId;

    requestIdRef.current += 1; // invalidate any in-flight requests
    setMobileActiveStep(null);
    setItemsDataForRM([]);
    setTechSectionData(null);
    setSelectedMaterialData(null);
    setOpenMaterialModal(false);
    setOpenViewItemsModal(false);
    setViewItemsData(null);
    setLoading(false);
    setShowDownloadMenu(false);

    const step = journeySteps.find((s) => s.key === selectedJourneyKey);
    if (step && dppId) {
      openJourneyStep(step);
    } else {
      setSelectedJourneyKey(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dppId]);


  const permissionsLoaded = isFromQRCode || (modulesData && modulesData.length > 0);

  useEffect(() => {
    if (isReady && mainData?.productLifecycleJourney && !selectedJourneyKey && dppId && permissionsLoaded) {

      const validSteps = journeySteps.filter((step) => {

        if (!roleId && step.key !== "technicalDocuments") {
          return false;
        }
        if (roleId && !step.view) {
          return false;
        }
        // if (!step.view) return false;

        const stageData = mainData.productLifecycleJourney[step.key];
        const orderNumber = stageData?.orderNumber;

        const isAvailable =
          orderNumber !== undefined &&
          orderNumber !== null &&
          orderNumber !== "n/a" &&
          orderNumber !== "" &&
          String(orderNumber).trim() !== "0";

        return isAvailable;
      });

      if (validSteps.length > 0) {
        const manufacturingStep = validSteps.find((step) => step.key === "manufacturer");

        let stepToOpen = null;

        if (manufacturingStep) {
          stepToOpen = manufacturingStep;
        } else {
          validSteps.sort((a, b) => {
            const numA = Number(mainData.productLifecycleJourney[a.key].orderNumber) || 999;
            const numB = Number(mainData.productLifecycleJourney[b.key].orderNumber) || 999;
            return numA - numB;
          });
          stepToOpen = validSteps[0];
        }

        openJourneyStep(stepToOpen);
      }
    }
  }, [isReady, mainData, dppId, selectedJourneyKey, permissionsLoaded]);

  if (!mainData || Object.keys(mainData)?.length === 0) {
    return (
      <div style={{ width: "100%", maxWidth: "100%", overflowX: "hidden", padding: "8px 4px" }}>
        <style>{`
          @keyframes skeleton-loading {
            0% { opacity: 0.6; }
            50% { opacity: 1; }
            100% { opacity: 0.6; }
          }
        `}</style>
        <div
          style={{
            background: "white",
            borderRadius: "10px",
            marginTop: "10px",
            marginBottom: "10px",
            padding: "20px",
          }}
        >
          <div style={{ display: "flex", gap: "20px" }}>
            <div
              style={{
                width: "110px",
                height: "120px",
                borderRadius: "8px",
                background: "#f4f4f4",
                animation: "skeleton-loading 1.5s infinite",
              }}
            />
            {/* Details skeleton */}
            <div style={{ flex: 1 }}>
              <div
                style={{
                  height: "24px",
                  borderRadius: "4px",
                  background: "#f4f4f4",
                  animation: "skeleton-loading 1.5s infinite",
                  marginBottom: "12px",
                  width: "60%",
                }}
              />
              <div
                style={{
                  height: "16px",
                  borderRadius: "4px",
                  background: "#f4f4f4",
                  animation: "skeleton-loading 1.5s infinite",
                  marginBottom: "20px",
                  width: "40%",
                }}
              />
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  style={{
                    height: "12px",
                    borderRadius: "4px",
                    background: "#f4f4f4",
                    animation: "skeleton-loading 1.5s infinite",
                    marginBottom: "8px",
                    width: `${70 + i * 10}%`,
                  }}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Skeleton for Timeline */}
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "20px",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <div style={{ marginBottom: "30px" }}>
            <div
              style={{
                height: "20px",
                borderRadius: "4px",
                background: "#f4f4f4",
                animation: "skeleton-loading 1.5s infinite",
                width: "35%",
              }}
            />
          </div>
          <div style={{ display: "flex", gap: "16px", overflowX: "auto" }}>
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    background: "#f4f4f4",
                    animation: "skeleton-loading 1.5s infinite",
                    marginBottom: "12px",
                  }}
                />
                <div
                  style={{
                    height: "14px",
                    width: "80px",
                    borderRadius: "4px",
                    background: "#f4f4f4",
                    animation: "skeleton-loading 1.5s infinite",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  const productDetails = mainData?.mainCard?.productDetails || {};
  const brandLogoUrl = productDetails?.brandLogoUrl || null;

  const co2Value =
    productDetails?.carbonFootprint ||
    mobileActiveStep?.mainHeader?.carbonFootprint ||
    "—";
  const energyValue =
    mobileActiveStep?.mainHeader?.energyUsage ||
    mobileActiveStep?.mainHeader?.electricityConsumption ||
    "—";
  const waterValue =
    mobileActiveStep?.mainHeader?.waterUsage ||
    mobileActiveStep?.mainHeader?.waterConsumption ||
    "—";
  const recyclabilityValue =
    mobileActiveStep?.mainHeader?.recyclabilityScore || "—";

  const moduleName = mobileActiveStep?.mainHeader?.moduleName;
  // For each list: use the step's own data if present, otherwise fall back to the
  // data returned by the technical documents API (so every step shows them all).
  const pickList = (key) =>
    mobileActiveStep?.[key]?.length > 0 ? mobileActiveStep[key] : techSectionData?.[key] || [];
  const documentsList = pickList("technicalDocuments");
  const certificationsList = pickList("certifications");
  const testCertsList = pickList("testCertificatesName");
  const supplierCertsList = pickList("supplierCertificatesName");
  const otherCertsList = pickList("othersCertificatesName");

  // Groups shown in the "Certificates" section.
  // Empty groups are dropped so their headings never appear.
  const certGroups = [
    { title: "Certifications & Compliance", items: certificationsList.map((c) => (typeof c === "string" ? c : c?.docType || c?.name)) },
    { title: "Test Certificates", items: testCertsList.map((c) => c?.docType) },
    { title: "Supplier Certificates", items: supplierCertsList.map((c) => c?.docType) },
    { title: "Other Certificates", items: otherCertsList.map((c) => c?.docType) },
  ]
    .map((g) => ({ ...g, items: g.items.filter(Boolean) }))
    .filter((g) => g.items.length > 0);

  const opsData = mobileActiveStep?.operations;

  const detailInfo = mobileActiveStep?.detailInformation || {};
  const usageInfo = mobileActiveStep?.productUsageHistory || {};
  let detailRows = [];
  let showDetailedInfo = false;

  if (moduleName === "Manufacturing") {
    showDetailedInfo = true;
    detailRows = [
      ["Production Date", detailInfo.productionDate || "—"],
      ["Batch Number", detailInfo.batchNumber || "—"],
      ["Workers", detailInfo.workers || "—"],
      ["Units Produced", detailInfo.unitsProduced || "—"],
      ["Factory Manager", detailInfo.factoryManager || "—"],
      ["Quality Yield", detailInfo.qualityYield ? `${detailInfo.qualityYield} %` : "—"],
      ["Waste Generated", detailInfo.wasteGenerated ? `${detailInfo.wasteGenerated} %` : "—"],
      ["Company Name", detailInfo.companyName || "—"],
      ["City", detailInfo.city || "—"],
      ["Street", detailInfo.street || "—"],
      ["Country", detailInfo.nationalCode || "—"],
      ["Item Code", detailInfo.itemCode || "—"],
      ["Item Description", detailInfo.itemDescription || "—"],
      ["Variant Name", detailInfo.variantName || "—"],
      ["Quantity", `${detailInfo.quantity || "—"} ${detailInfo.quantityUOM || ""}`.trim()],
      ["Actual Mass", `${detailInfo.actualMass || "—"} ${detailInfo.actualMassUOM || ""}`.trim()],
    ];
  } else if (moduleName === "Chain Of Custody") {
    showDetailedInfo = true;
    detailRows = [
      ["Total Transit Time (days)", detailInfo.totalTransitTime ?? "—"],
      ["Handling Events", detailInfo.handlingEvents ? `${detailInfo.handlingEvents} Stages` : "—"],
      ["Tracking Id", detailInfo.trackingId ?? "—"],
      ["Traceability Status", detailInfo.traceabilityStatus ?? "—"],
      ["Transit Mode", detailInfo.transitMode ?? "—"],
      ["Last Scan", detailInfo.lastScan ?? "—"],
      hasBatteryIndustry && ["Temperature Range", detailInfo.temperatureRange ?? "—"],

    ].filter(Boolean);
  } else if (moduleName === "Durability") {
    showDetailedInfo = true;
    detailRows = [["Expected Lifespan", detailInfo.expectedLifespan || "—"]];
    if (hasIndustryId) {
      detailRows.push(
        ["Abrasion Resistance", detailInfo.abrasionResistance ? `${detailInfo.abrasionResistance} Cycles` : "—"],
        ["Color Fastness", detailInfo.colorFastness ? `Rating ${detailInfo.colorFastness}` : "—"],
        ["Shrinkage Percentage", detailInfo.shrinkagePercentage ? `${detailInfo.shrinkagePercentage} %` : "—"],
        ["Humidity Resistance", detailInfo.humidityResistance || "—"],
        ["Wear Resistance", detailInfo.wearResistance || "—"],
        ["Pilling Resistance", detailInfo.pillingResistance ? `${detailInfo.pillingResistance} %` : "—"],
      );
    } else {
      detailRows.push(

        ["Temperature Range", detailInfo.temperatureRange || "—"],
      );
      if (hasSteelIndustry) {
        detailRows.push(["Material Strength", detailInfo.materialStrength || "—"]);
      }
      detailRows.push(["Test Results", detailInfo.testResults || "—"]);
      if (hasBatteryIndustry) {
        detailRows.push(["Battery Degradation", detailInfo.batteryDegradation || "—"],
          ["Drop Test", detailInfo.dropTest || "—"],
          ["State Of Health", detailInfo.stateOfHealth || "—"],

        );

      }
    }
    detailRows.push(
      ["Warranty", detailInfo.warranty || "—"],
      ["Quality Score", detailInfo.qualityScore || "—"],

    );
  } else if (moduleName === "Packaging & Waste Management") {
    showDetailedInfo = true;
    detailRows = [
      ["Packaging Weight (Kg)", detailInfo.packagingWeight || "—"],
      ["Material Source", detailInfo.materialSource || "—"],

      hasBatteryIndustry && ["Plastic Content", detailInfo.plasticContent ? `${detailInfo.plasticContent} %` : "—"],
      hasBatteryIndustry && ["Bio Degradability", detailInfo.biodegradability ? `${detailInfo.biodegradability} %` : "—"],

      ["Carbon Footprint", detailInfo.carbonFootprint ? `${detailInfo.carbonFootprint} kg CO₂e` : "—"],
      ["Waste Generation", detailInfo.wasteGeneration ? `${detailInfo.wasteGeneration} %` : "—"],
      ["Reusability", detailInfo.reusability ? `${detailInfo.reusability} %` : "—"],
      ["Disposal Instructions", detailInfo.disposalInstructions || "—"],
      ["Take Back Program", detailInfo.takeBackProgram || "—"],
    ].filter(Boolean);
  } else if (moduleName === "Product Usage History") {
    showDetailedInfo = true;
    detailRows = [
      ["Total Operating Time", usageInfo.totalOperatingTime || "—"],
      hasBatteryIndustry && ["Total Charging Cycles", usageInfo.totalChargingCycles || "—"],
      hasBatteryIndustry && ["Total Discharging Cycles", usageInfo.totalDischargingCycles || "—"],
      hasBatteryIndustry && ["Average SOC", usageInfo.averageSoc || "—"],
      ["Min/Max Operating Temp", `${usageInfo.minOperatingTemp || "—"} / ${usageInfo.maxOperatingTemp || "—"}`],
      hasBatteryIndustry && ["Min/Max Charging Temp", `${usageInfo.minChargingTemp || "—"} / ${usageInfo.maxChargingTemp || "—"}`],
      ["Min/Max Storage Temp", `${usageInfo.minStorageTemp || "—"} / ${usageInfo.maxStorageTemp || "—"}`],
      hasBatteryIndustry && ["Total Energy Charged", usageInfo.totalEnergyCharged || "—"],
      hasBatteryIndustry && ["Total Energy Discharged", usageInfo.totalEnergyDischarged || "—"],
      hasBatteryIndustry && ["Charging Method", usageInfo.chargingMethod || "—"],
      hasBatteryIndustry && ["Charging Frequency", usageInfo.chargingFrequency || "—"],
      hasBatteryIndustry && ["Avg Charging Duration", usageInfo.averageChargingDuration || "—"],
      hasBatteryIndustry && ["Avg Charging Rate", usageInfo.averageChargingRate || "—"],
    ].filter(Boolean);
  } else if (moduleName === "Environmental Impact & Sustainability") {
    showDetailedInfo = true;
    detailRows = [
      ["Total CO₂ Emissions", `${formatFloat(detailInfo.totalCO2Emissions)} kg CO₂`],
      ["Raw Materials (CO₂ Emissions)", `${formatFloat(detailInfo.rawMaterial)} kg CO₂`],
      ["Manufacturing (CO₂ Emissions)", `${formatFloat(detailInfo.manufacturing)} kg CO₂`],
      ["Carbon Offset", `${formatFloat(detailInfo.carbonOffset)} kg CO₂`],
      ["Recycled Content Used", `${formatFloat(detailInfo.recycledContent)} %`],
      ["Water Footprint", detailInfo.WaterFootprint ?? "—"],
      ["Energy Source", detailInfo.energySource ?? "—"],
      ["Sustainability Score (%)", detailInfo.sustainabilityScore != null ? `${detailInfo.sustainabilityScore} %` : "—"],
      ["End of Life Recovery (%)", `${detailInfo.endOfLifeRecovery || "—"} %`],
      ["Environmental Grade", detailInfo.environmentalGrade || "—"],
      ["Renewable Energy Used", detailInfo.renewableEnergyUsed || "—"],
      hasBatteryIndustry && ["Repaired Parts Value", detailInfo.repairedPartsValue || "—"],


    ].filter(Boolean);
  } else if (moduleName === "Repair, Remanufacture & Recycle") {
    showDetailedInfo = true;
    detailRows = [
      ["Return Date", detailInfo.returnDate ? String(detailInfo.returnDate).slice(0, 10) : "-"],
      ["Repair Actions", detailInfo.repairActions ? String(detailInfo.repairActions).slice(0, 10) : "-"],
      (hasBatteryIndustry || hasIndustryId) && ["Second Life Suitable", detailInfo.isSecondLifeSuitable ? String(detailInfo.isSecondLifeSuitable).slice(0, 10) : "-"],
      (hasBatteryIndustry || hasIndustryId) && ["Second Life Duration", detailInfo.secondLifeDuration ? String(detailInfo.secondLifeDuration).slice(0, 10) : "-"],
      (hasBatteryIndustry || hasIndustryId) && ["Reuse Potential", detailInfo.reusePotential ? String(detailInfo.reusePotential).slice(0, 10) : "-"],

      [
        "Description",
        detailInfo.description
          ? detailInfo.description.length > 50
            ? `${detailInfo.description.slice(0, 50)}...`
            : detailInfo.description
          : "—",
      ],
    ].filter(Boolean);
  }

  const showCareInstructions = moduleName === "Durability" && hasIndustryId;
  const careRows = [
    [
      "Wash Temperature",
      mobileActiveStep?.careAndUseInstructions?.washTemperature
        ? `${mobileActiveStep.careAndUseInstructions.washTemperature} °C`
        : "—",
    ],
    ["Ironing Instructions", mobileActiveStep?.careAndUseInstructions?.ironingInstructions || "—"],
    ["Dry Clean Status", mobileActiveStep?.careAndUseInstructions?.dryCleanStatus || "—"],
    ["Tumble Dry Instructions", mobileActiveStep?.careAndUseInstructions?.tumbleDryInstructions || "—"],
    ["Bleach Allowed", mobileActiveStep?.careAndUseInstructions?.bleachAllowed || "—"],
  ];

  const isRawMaterialModule = moduleName === "Raw Material";
  const uniqueRmItems = (itemsDataForRM || []).filter(
    (value, index, self) => index === self.findIndex((t) => t.rmItemCode === value.rmItemCode),
  );

  // ---- hide accordions that have no real data (only "—" placeholders) ----
  const isEmptyVal = (v) => {
    if (v === null || v === undefined) return true;
    const t = String(v).trim();
    return t === "" || /^[—-](\s|$)/.test(t);
  };
  const rowsHaveData = (rows) => (rows || []).some(([, v]) => !isEmptyVal(v));

  const chemRows = mobileActiveStep?.chemicalAnalysis
    ? [
      ["Mass Fraction AI", mobileActiveStep.chemicalAnalysis.massFraction_AI],
      ["Mass Fraction BE", mobileActiveStep.chemicalAnalysis.massFraction_Be],
      ["Mass Fraction C", mobileActiveStep.chemicalAnalysis.massFraction_C],
      ["Mass Fraction CR", mobileActiveStep.chemicalAnalysis.massFraction_Cr],
      ["Mass Fraction CU", mobileActiveStep.chemicalAnalysis.massFraction_Cu],
      ["Mass Fraction MN", mobileActiveStep.chemicalAnalysis.massFraction_Mn],
      ["Mass Fraction NB", mobileActiveStep.chemicalAnalysis.massFraction_Nb],
      ["Mass Fraction P", mobileActiveStep.chemicalAnalysis.massFraction_P],
      ["Mass Fraction PB", mobileActiveStep.chemicalAnalysis.massFraction_Pb],
      ["Mass Fraction MO", mobileActiveStep.chemicalAnalysis.massFraction_Mo],
    ]
    : [];

  const hasTestData = (t) => !!t && Object.values(t).some((v) => !isEmptyVal(v));
  const hasProductTestData = hasIndustryId
    ? hasTestData(mobileActiveStep?.textileTest)
    : hasBatteryIndustry
      ? hasTestData(mobileActiveStep?.thermalStabilityTest) ||
      hasTestData(mobileActiveStep?.shortCircuitOverchargeTest)
      : hasTestData(mobileActiveStep?.notchimpactTest) ||
      hasTestData(mobileActiveStep?.tensileTest) ||
      hasTestData(mobileActiveStep?.hardnessTest);

  const testModalFields = [
    ["Yield Test Name", "yiTestName", (v) => v],
    ["Abrasion Resistance", "abrasionResistance", (v) => `${v} Cycles`],
    ["Overcharge Test", "overchargeTest", (v) => v],
    ["Overcharge Test Value", "overchargeTestValue", (v) => v],
    ["Short Circuit Test", "shortCircuitTest", (v) => v],
    ["Short Circuit Test Value", "shortCircuitTestValue", (v) => v],
    ["Pilling Resistance", "pillingResistance", (v) => `${v} %`],
    ["Color Fastness", "colorFastness", (v) => `${v} / 5`],
    ["Shrinkage Percentage", "shrinkagePercentage", (v) => `${v} %`],
    ["Yield Methodology", "yiMethodology", (v) => v],
    ["Tensile Test Name", "teTestName", (v) => v],
    ["Tensile Strength Mean", "tensileStrengthMean", (v) => v],
    ["Hardness Test Name", "hrTestName", (v) => v],
    ["Hardness Mean", "hardnessMean", (v) => v],
    ["Hardness Individual Values", "hardnessIndividualValues", (v) => v],
    ["Impact Test Name", "imTestName", (v) => v],
    ["Notch Impact Strength Mean", "notchimpactStrengthMean", (v) => v],
    ["Impact LL", "impactLL", (v) => v],
    ["Impact UL", "impactUL", (v) => v],
    ["Impact UOM", "impactUOM", (v) => v],
    ["Yield Proof Strength Mean", "yeildProofStrengthMean", (v) => v],
    ["Yield LL", "yieldLL", (v) => v],
    ["Yield UL", "yieldUL", (v) => v],
    ["Yield UOM", "yieldUOM", (v) => v],
    ["Tensile Methodology", "teMethodology", (v) => v],
    ["Tensile LL", "tensileLL", (v) => v],
    ["Tensile UL", "tensileUL", (v) => v],
    ["Tensile UOM", "tensileUOM", (v) => v],
    ["Impact Methodology", "imMethodology", (v) => v],
    ["HR Methodology", "hrMethodology", (v) => v],
    ["HRC LL", "hrcLL", (v) => v],
    ["HRC UL", "hrcUL", (v) => v],
    ["HR UOM", "hrUOM", (v) => v],
    ["HB Test Name", "hbTestName", (v) => v],
    ["HB Methodology", "hbMethodology", (v) => v],
    ["HB LL", "hbLL", (v) => v],
    ["HB UL", "hbUL", (v) => v],
    ["HB UOM", "hbUOM", (v) => v],
    ["Impact Test Name (CH)", "impactTestName", (v) => v],
    ["Impact Methodology (CH)", "impactMethodology", (v) => v],
    ["CH LL", "chLL", (v) => v],
    ["CH UL", "chUL", (v) => v],
    ["CH UOM", "chUOM", (v) => v],
  ];
  const thermalFields = [
    ["Test Result", "testResult", (v) => v],
    ["Min Operating Temp", "minOperatingTemp", (v) => v],
    ["Max Operating Temp", "maxOperatingTemp", (v) => v],
    ["Thermal Stability Test Temp", "thermalStabilityTestTemp", (v) => v],
    ["Thermal Runaway Onset Temp", "thermalRunawayOnsetTemp", (v) => v],
    ["Temperature Rise", "temperatureRise", (v) => v],
    ["Thermal Exposure Duration", "thermalExposureDuration", (v) => v],
  ];

  const testModalTitle =
    (testType === "tensileTest" && "Tensile Test") ||
    (testType === "hardnessTest" && "Hardness Test") ||
    (testType === "notchimpactTest" && "Notch Impact Test") ||
    (testType === "textileTest" && "Textile Test") ||
    (testType === "thermalStability" && "Thermal Stability Test") ||
    (testType === "shortCircuitOverchargeTest" && "Short Circuit & Overcharge Test") ||
    "";

  return (
    <div className="dpp-mobile-view-container">
      <style>{`
        .dpp-mobile-view-container {
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
          padding: 8px 4px;
          display: flex;
          flex-direction: column;
          gap: 16px;
          font-family: Inter, system-ui, -apple-system, sans-serif;
        }

        .mobile-product-card {
          background: #ffffff;
          border-radius: 16px;
          padding: 16px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.06);
          border: 1px solid #e2e8f0;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        /* ---------- HEADER (image + logo) ----------
           Static layout (scroll animation is disabled).
           z-index: 0 creates a local stacking context so inner z-indexes
           can never outrank dropdowns outside the header. */
        .mobile-product-header {
          position: relative;
          width: 100%;
          height: 120px;
          margin-bottom: 12px;
          z-index: 0;
        }

        .mobile-product-img-box {
          position: absolute;
          top: 0;
          left: 0;
          width: 110px; height: 120px; border-radius: 12px; background: #f8fafc;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0; border: 1px solid #f1f5f9;
          transform-origin: top center;
          will-change: transform, box-shadow;
          backface-visibility: hidden;
          transition: box-shadow 0.2s ease;
          z-index: 1;
        }

        /* clip layer for the image (kept separate so the share dropdown isn't clipped) */
        .mobile-product-img-clip {
          position: absolute;
          inset: 0;
          overflow: hidden;
          border-radius: inherit;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .mobile-product-img-box img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          object-fit: contain;
          will-change: transform;
          transform-origin: center center;
        }

        .mobile-brand-section {
          position: absolute;
          top: 20px;
          /* centered in the space to the right of the image */
          left: calc(110px + (100% - 110px - 140px) / 2);
          width: 140px;
          height: 80px;
          display: flex; justify-content: center; align-items: center;
          transform-origin: left top;
          will-change: transform;
          backface-visibility: hidden;
          z-index: 0;
        }
        .mobile-brand-logo { max-width: 100%; max-height: 100%; object-fit: contain; }

        .mobile-img-share-btn {
          position: absolute;
          bottom: 6px;
          right: 6px;
          background: rgba(255, 255, 255, 0.9);
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: 50%;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          outline: none;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
          transition: transform 0.15s ease;
          z-index: 10;
        }

        .mobile-img-share-btn:active {
          transform: scale(0.9);
        }

        .mobile-image-download-menu {
          position: absolute;
          top: 100%;
          left: 0;
          margin-top: 6px;
          background: #ffffff;
          border-radius: 14px;
          padding: 10px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.18);
          border: 1px solid #e2e8f0;
          display: flex;
          flex-direction: column;
          gap: 6px;
          min-width: 160px;
          z-index: 100;
          animation: popUpFade 0.2s ease-out;
        }

        .mobile-product-title { font-size: 16px; font-weight: 700; color: #0f172a; margin-top: 4px; }
        .mobile-details-list { display: flex; flex-direction: column; gap: 6px; font-size: 13px; color: #334155; width: 100%; margin-top: 4px; }
        .mobile-details-row { display: flex; gap: 6px; line-height: 1.4; }
        .mobile-details-label { font-weight: 700; color: #0f172a; white-space: nowrap; }
        .mobile-details-val { color: #475569; word-break: break-word; }

        .mobile-impact-box {
          background: #ffffff; border: 1px solid #e2e8f0; border-radius: 14px; padding: 14px;
          display: flex; flex-direction: column; align-items: center; gap: 12px;
        }
        .mobile-impact-title { font-size: 16px; font-weight: 700; color: #0f172a; }
        .mobile-impact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; width: 100%; }
        .mobile-impact-tile { background: #eef6ff; border-radius: 12px; padding: 12px; display: flex; flex-direction: column; align-items: center; text-align: center; gap: 6px; }
        .mobile-impact-tile-label { font-size: 11px; color: #475569; font-weight: 600; }
        .mobile-impact-tile-icon { width: 28px; height: 28px; color: #2563eb; }
        .mobile-impact-tile-val { font-size: 13px; font-weight: 700; color: #0f172a; }

        .mobile-lifecycle-container { background: #eef4ff; border-radius: 16px; padding: 16px 12px; display: flex; flex-direction: column; gap: 16px; border: 1px solid #dbeafe; }
        .mobile-lifecycle-header { text-align: center; font-size: 17px; font-weight: 700; color: #0f172a; }

        .mobile-tabs-scroll { display: flex; gap: 8px; overflow-x: auto; padding-bottom: 6px; -webkit-overflow-scrolling: touch; scroll-snap-type: x mandatory; }
        .mobile-tabs-scroll::-webkit-scrollbar { display: none; }

        /* scroll indicator under the lifecycle tabs */
        .mobile-tabs-track { position: relative; height: 5px; background: #cfdcf7; border-radius: 999px; margin-top: -8px; overflow: hidden; }
        .mobile-tabs-thumb { position: absolute; top: 0; height: 100%; background: #3b82f6; border-radius: 999px; transition: left 0.08s linear; }

        .mobile-tab-btn { flex: 0 0 auto; padding: 8px 14px; border-radius: 8px; font-size: 12px; font-weight: 600; border: 1px solid #cbd5e1; background: #ffffff; color: #334155; cursor: pointer; white-space: nowrap; transition: all 0.2s ease; }
        .mobile-tab-btn.active { background: #3b82f6; color: #ffffff; border-color: #3b82f6; box-shadow: 0 2px 8px rgba(59,130,246,0.3); }
        .mobile-tab-btn.unavailable { opacity: 0.5; }

        .mobile-stage-content { display: flex; flex-direction: column; gap: 14px; width: 100%; }
        .mobile-stage-title { text-align: center; font-size: 18px; font-weight: 700; color: #0f172a; margin-top: 4px; }

        .mobile-kpi-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; width: 100%; }
        .mobile-kpi-card { background: #ffffff; border-radius: 12px; padding: 12px; border: 1px solid #e2e8f0; box-shadow: 0 2px 6px rgba(0,0,0,0.02); display: flex; flex-direction: column; gap: 4px; }
        .mobile-kpi-label { font-size: 11px; color: #64748b; font-weight: 500; }
        .mobile-kpi-val { font-size: 13px; font-weight: 700; color: #0f172a; word-break: break-word; }

        .mobile-material-card { background: #ffffff; border-radius: 12px; padding: 12px 16px; border: 1px solid #e2e8f0; display: flex; align-items: center; gap: 8px; font-size: 13px; flex-wrap: wrap; }
        .mobile-material-chip { background: #eff6ff; color: #1d4ed8; padding: 4px 10px; border-radius: 6px; font-weight: 600; font-size: 12px; border: 1px solid #bfdbfe; }
        .mobile-material-chip.clickable {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          cursor: pointer;
          background: #dbeafe;
          border-color: #60a5fa;
          box-shadow: 0 1px 3px rgba(37, 99, 235, 0.25);
          text-decoration: underline;
          text-underline-offset: 3px;
          transition: background 0.15s ease, transform 0.1s ease;
        }
        .mobile-material-chip.clickable:hover { background: #bfdbfe; }
        .mobile-material-chip.clickable:active { transform: scale(0.96); background: #bfdbfe; }

        .mobile-accordion { background: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.03); }
        .mobile-accordion-header { display: flex; justify-content: space-between; align-items: center; padding: 14px 16px; cursor: pointer; font-weight: 700; font-size: 15px; color: #0f172a; background: #ffffff; }
        .mobile-accordion-body { padding: 12px 16px 16px; border-top: 1px dashed #e2e8f0; display: flex; flex-direction: column; gap: 12px; }

        .mobile-info-rows { display: flex; flex-direction: column; gap: 8px; }
        .mobile-info-row { display: flex; justify-content: space-between; padding: 6px 0; border-bottom: 1px dashed #f1f5f9; font-size: 13px; gap: 12px; }
        .mobile-info-row:last-child { border-bottom: none; }
        .mobile-info-key { color: #64748b; font-weight: 500; flex-shrink: 0; }
        .mobile-info-val { color: #0f172a; font-weight: 600; text-align: right; max-width: 60%; word-break: break-word; }

        .mobile-rm-card { padding: 12px; background: #f8fafc; border-radius: 8px; border: 1px solid #eef2ff; }

        /* ---------- OPERATIONS TIMELINE ----------
           Each item draws its own connector down to the NEXT dot, and the
           last item has no segment, so the line always ends at the last dot. */
        .mobile-ops-timeline { display: flex; flex-direction: column; width: 100%; box-sizing: border-box; }
        .mobile-ops-item { position: relative; padding-left: 28px; padding-bottom: 14px; }
        .mobile-ops-item.is-last,
        .mobile-ops-item:last-child { padding-bottom: 0; }
        .mobile-ops-dot {
          position: absolute; left: 0; top: 16px;
          width: 12px; height: 12px; border-radius: 50%;
          background: #3b82f6; box-shadow: 0 0 0 3px #dbeafe;
          z-index: 2;
        }
        .mobile-ops-line {
          position: absolute;
          left: 5px;           /* centre of the 12px dot */
          top: 22px;           /* centre of this dot */
          bottom: -22px;       /* reaches centre of the next dot */
          width: 2px;
          background: #93c5fd;
          border-radius: 2px;
          z-index: 1;
        }
        .mobile-ops-item::before,
        .mobile-ops-item:last-child::before,
        .mobile-ops-item.is-last::before,
        .mobile-ops-item.is-last .mobile-ops-line {
          display: none !important;
          content: none !important;
        }
        .mobile-ops-card {
          background: #f5f8ff; border: 1px solid #dbeafe; border-radius: 12px;
          padding: 12px 14px; display: flex; flex-direction: column; gap: 6px;
          box-sizing: border-box; min-width: 0;
        }
        .mobile-ops-title { font-size: 14px; font-weight: 700; color: #0f172a; word-break: break-word; }
        .mobile-ops-person { font-size: 12px; font-weight: 500; color: #475569; }
        .mobile-ops-row { display: flex; gap: 10px; font-size: 12px; }
        .mobile-ops-key { color: #64748b; flex-shrink: 0; }
        .mobile-ops-val { color: #0f172a; font-weight: 600; word-break: break-word; }

        /* ---------- Divider before Certificates & Documents ----------
           Layout is: [line] [label] [line] with both lines flex:1,
           so the label is always exactly in the middle. */
        .mobile-resources-divider {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: 10px;
          width: 100%;
          box-sizing: border-box;
          margin: 6px 0;
        }
        .mobile-resources-divider-line { flex: 1 1 0; height: 1px; background: #cbd5e1; }
        .mobile-resources-divider-label {
          flex: 0 0 auto;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 5px 14px;
          border-radius: 999px;
          background: #3b82f6;
          color: #ffffff;
          font-size: 12px;
          font-weight: 700;
          white-space: nowrap;
        }

        /* ---------- Certificates & Documents (two separate sections) ---------- */
        .mobile-certdoc-section { background: #e0e9ff; border-radius: 14px; padding: 16px 12px; display: flex; flex-direction: column; gap: 14px; }
        .mobile-certdoc-section.docs { background: #fff1e6; }
        .mobile-certdoc-title { text-align: center; font-size: 18px; font-weight: 700; color: #0f172a; }
        .mobile-certdoc-card { background: #fafafa; border-radius: 12px; padding: 14px 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.12); display: flex; flex-direction: column; gap: 14px; }
        .mobile-certdoc-group { display: flex; flex-direction: column; gap: 8px; }
        .mobile-certdoc-heading { text-align: center; font-size: 13px; font-weight: 700; color: #0f172a; }
        .mobile-certdoc-chips { display: flex; flex-direction: column; align-items: flex-start; gap: 8px; }
        .mobile-certdoc-chip { display: inline-flex; align-items: center; gap: 10px; padding: 6px 12px; background: #e6eefc; border: 1px solid #8ea6cf; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.15); font-size: 13px; font-weight: 600; color: #0f172a; max-width: 100%; }
        .mobile-certdoc-doc { display: inline-flex; align-items: center; gap: 8px; padding: 8px 10px; background: #fde6d0; border: 1px solid #f5a25d; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.15); cursor: pointer; max-width: 100%; box-sizing: border-box; }
        .mobile-certdoc-doc-name { font-size: 13px; font-weight: 600; color: #0f172a; word-break: break-word; }

        /* ---------- Footer ---------- */
        .mobile-dev-footer {
          width: 100%;
          box-sizing: border-box;
          text-align: center;
          padding: 10px 8px 4px;
          font-size: 12px;
          line-height: 1.5;
          color: #64748b;
        }
        .mobile-dev-footer strong { color: #ff0000; font-weight: 700; }

        .mobile-action-buttons {
          display: flex;
          gap: 8px;
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          scroll-snap-type: x mandatory;
          padding-bottom: 4px;
          margin-top: 8px;
          box-sizing: border-box;
        }

        .mobile-action-buttons::-webkit-scrollbar {
          display: none;
        }

        .mobile-btn {
          flex: 1 0 auto;
          min-width: 105px;
          padding: 10px 14px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 700;
          color: #ffffff;
          border: none;
          cursor: pointer;
          outline: none;
          text-align: center;
          white-space: nowrap;
          transition: background-color 0.2s ease, transform 0.1s ease;
          scroll-snap-align: start;
        }

        .mobile-btn-green {
          background-color: #00b74a;
        }
        .mobile-btn-green:hover {
          background-color: #00913b;
        }

        .mobile-btn-blue {
          background-color: #2d68fe;
        }
        .mobile-btn-blue:hover {
          background-color: #1e4ed8;
        }

        .mobile-qr-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .mobile-qr-content {
          background: #ffffff;
          border-radius: 16px;
          padding: 24px;
          max-width: 320px;
          width: 90%;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        }

        .mobile-fab-container {
          position: fixed;
          bottom: 24px;
          right: 20px;
          z-index: 9999;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }

        .mobile-fab-btn {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: #2d68fe;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 14px rgba(45, 104, 254, 0.4);
          cursor: pointer;
          outline: none;
          transition: transform 0.2s ease, background-color 0.2s ease;
        }

        .mobile-fab-btn:active {
          transform: scale(0.92);
        }

        .mobile-download-popup {
          background: #ffffff;
          border-radius: 14px;
          padding: 12px;
          margin-bottom: 12px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
          border: 1px solid #e2e8f0;
          display: flex;
          flex-direction: column;
          gap: 8px;
          min-width: 170px;
          animation: popUpFade 0.2s ease-out;
        }

        @keyframes popUpFade {
          from {
            opacity: 0;
            transform: translateY(10px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .mobile-popup-header {
          font-size: 11px;
          font-weight: 700;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          padding-bottom: 4px;
          border-bottom: 1px solid #f1f5f9;
          text-align: center;
        }

        .mobile-popup-btn {
          padding: 10px 14px;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 600;
          border: none;
          cursor: pointer;
          outline: none;
          text-align: center;
          transition: background 0.15s ease;
        }

        .mobile-popup-excel {
          background: #f0fdf4;
          color: #15803d;
        }
        .mobile-popup-excel:active {
          background: #dcfce7;
        }

        .mobile-popup-json {
          background: #eff6ff;
          color: #1d4ed8;
        }
        .mobile-popup-json:active {
          background: #dbeafe;
        }

        .mobile-popup-qr {
          background: #faf5ff;
          color: #7e22ce;
        }
        .mobile-popup-qr:active {
          background: #f3e8ff;
        }
      `}</style>

      {/* TOP PRODUCT DETAILS CARD */}
      <div className="mobile-product-card">
        <div className="mobile-product-header" ref={headerRef}>
          <div className="mobile-product-img-box" ref={imgBoxRef}>
            <div className="mobile-product-img-clip">
              <img
                ref={imgInnerRef}
                src={productImage || "https://via.placeholder.com/150"}
                alt={productDetails?.productId || "Product Image"}
              />
            </div>
            {roleId && (<button
              className="mobile-img-share-btn"
              onClick={() => setShowDownloadMenu((prev) => !prev)}
              title="Download Options"
            >
              <FileDownloadIcon style={{ fontSize: "17px", color: "#0f172a" }} />

            </button>)}

            {(showDownloadMenu && roleId) && (
              <div className="mobile-image-download-menu">
                <div className="mobile-popup-header">Download Options</div>
                {downloadReport && (
                  <>
                    <button
                      className="mobile-popup-btn mobile-popup-excel"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDownload(1);
                        setShowDownloadMenu(false);
                      }}
                    >
                      Download Excel
                    </button>
                    <button
                      className="mobile-popup-btn mobile-popup-json"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDownload(0);
                        setShowDownloadMenu(false);
                      }}
                    >
                      Download JSON
                    </button>
                  </>
                )}
                <button
                  className="mobile-popup-btn mobile-popup-qr"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowQR(true);
                    setShowDownloadMenu(false);
                  }}
                >
                  QR Code
                </button>
              </div>
            )}
          </div>
          <div className="mobile-brand-section" ref={logoBoxRef}>
            {brandLogoUrl && <img src={brandLogoUrl} alt="Brand Logo" className="mobile-brand-logo" />}
          </div>
        </div>

        <div className="mobile-details-list">
          <div className="mobile-details-row">
            <span className="mobile-details-label">Brand Name :</span>
            <span className="mobile-details-val">{productDetails?.brandName || "—"}</span>
          </div>
          {productDetails?.size && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Size :</span>
              <span className="mobile-details-val">{productDetails?.size}</span>
            </div>
          )}
          <div className="mobile-details-row">
            <span className="mobile-details-label">Collection/Model :</span>
            <span className="mobile-details-val">
              {productDetails?.collectionModelType || productDetails?.productId || "—"}
            </span>
          </div>
          {(productDetails?.gtinNumber) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">GTIN NO :</span>
              <span className="mobile-details-val">
                {productDetails?.gtinNumber || "—"}
              </span>
            </div>
          )}
          {(productDetails?.batchNo || productDetails?.serialNo) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Batch/Serial No :</span>
              <span className="mobile-details-val">
                {productDetails?.batchNo || productDetails?.serialNo || "—"}
              </span>
            </div>
          )}
          <div className="mobile-details-row">
            <span className="mobile-details-label">Description :</span>
            <span className="mobile-details-val">{productDetails?.description || "—"}</span>
          </div>
          <div className="mobile-details-row">
            <span className="mobile-details-label">Manufacturer :</span>
            <span className="mobile-details-val">{productDetails?.manufacturer || "—"}</span>
          </div>
          <div className="mobile-details-row">
            <span className="mobile-details-label">Made in :</span>
            <span className="mobile-details-val">{productDetails?.madeIn || "—"}</span>
          </div>
          {productDetails?.quantity && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Quantity :</span>
              <span className="mobile-details-val">
                {productDetails?.quantity} {productDetails?.quantityUOM || ""}
              </span>
            </div>
          )}
          {(productDetails?.dimensions && hasSteelIndustry || hasBatteryIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Dimensions :</span>
              <span className="mobile-details-val">
                {productDetails?.dimensions || ""}
              </span>
            </div>
          )}
          {(productDetails?.ceMarking && hasSteelIndustry || hasBatteryIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">CE Marking :</span>
              <span className="mobile-details-val">
                {productDetails?.ceMarking || ""}
              </span>
            </div>
          )}

          {(productDetails?.customerPartNumber && hasSteelIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Customer Part Number :</span>
              <span className="mobile-details-val">
                {productDetails?.customerPartNumber || ""}
              </span>
            </div>
          )}

          {(productDetails?.drawingRevision && hasSteelIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Drawing Revision :</span>
              <span className="mobile-details-val">
                {productDetails?.drawingRevision || ""}
              </span>
            </div>
          )}

          {(productDetails?.materialGrade && hasSteelIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Material Grade :</span>
              <span className="mobile-details-val">
                {productDetails?.materialGrade || ""}
              </span>
            </div>
          )}
          {(productDetails?.castingProcess && hasSteelIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Casting Process :</span>
              <span className="mobile-details-val">
                {productDetails?.castingProcess || ""}
              </span>
            </div>
          )}
          {(productDetails?.nominalVoltage && hasBatteryIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Nominal Voltage :</span>
              <span className="mobile-details-val">
                {productDetails?.nominalVoltage || ""}
              </span>
            </div>
          )}
          {(productDetails?.powerRating && hasBatteryIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Power Rating :</span>
              <span className="mobile-details-val">
                {productDetails?.powerRating || ""}
              </span>
            </div>
          )}
          {(productDetails?.ratedCapacity && hasBatteryIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Rated Capacity :</span>
              <span className="mobile-details-val">
                {productDetails?.ratedCapacity || ""}
              </span>
            </div>
          )}
          {(productDetails?.energyDensity && hasBatteryIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Energy Density :</span>
              <span className="mobile-details-val">
                {productDetails?.energyDensity || ""}
              </span>
            </div>
          )}
          {(productDetails?.batteryCellFormat && hasBatteryIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Battery Cell Format :</span>
              <span className="mobile-details-val">
                {productDetails?.batteryCellFormat || ""}
              </span>
            </div>
          )}
          {(productDetails?.batteryChemistry && hasBatteryIndustry) && (
            <div className="mobile-details-row">
              <span className="mobile-details-label">Battery Chemistry :</span>
              <span className="mobile-details-val">
                {productDetails?.batteryChemistry || ""}
              </span>
            </div>
          )}


          <div className="mobile-details-row">
            <span className="mobile-details-label">Material :</span>
            <span className="mobile-details-val">{mainData?.mainCard?.rawMaterials?.join(" ") || "—"}</span>
          </div>
        </div>
        {/* PRODUCT DETAILS (aligned with desktop PowerBankDetails) */}
        {(() => {
          const pd = productDetails || {};
          const t = (v) => (typeof v === "string" ? v.trim() : v) || "-";

          // [label, value, visible]
          const rows = [
            ["Batch/Serial No", pd.serialNo || "NA", true],
            ["Brand Name", pd.brandName || "-", true],
            ["Description", pd.description || "-", true],

            // Textile industry
            ["Collection/Model", pd.collectionModelType || "-", hasIndustryId],
            ["GTIN Number", pd.gtinNumber || "-", hasIndustryId],
            ["SKU", pd.sku || "-", hasIndustryId],
            ["Size", pd.size || "-", hasIndustryId],

            ["Manufacturer", pd.manufacturer || "-", true],
            ["Made in", pd.madeIn || "-", true],
            ["Quantity", `${pd.quantity ?? ""} ${pd.quantityUOM || ""}`.trim() || "-", true],

            // Battery industry
            ["Nominal Voltage", t(pd.nominalVoltage), hasBatteryIndustry],
            ["Power Rating", t(pd.powerRating), hasBatteryIndustry],
            ["Energy Density", t(pd.energyDensity), hasBatteryIndustry],
            ["Battery Cell Format", t(pd.batteryCellFormat), hasBatteryIndustry],
            ["Battery Chemistry", t(pd.batteryChemistry), hasBatteryIndustry],

            ["Dimensions", t(pd.dimensions), true],
            ["CE Marking", t(pd.ceMarking), true],

            // Steel industry
            ["Customer Part Number", t(pd.customerPartNumber), hasSteelIndustry],
            ["Drawing Revision", t(pd.drawingRevision), hasSteelIndustry],
            ["Material Grade", t(pd.materialGrade), hasSteelIndustry],
            ["Casting Process", t(pd.castingProcess), hasSteelIndustry],
          ].filter(([, , visible]) => visible);

          return (
            <>
              {/* {pd.productId && <div className="mobile-product-title">{pd.productId}</div>} */}

              {/* <div className="mobile-details-list">
                {rows.map(([label, value]) => (
                  <div key={label} className="mobile-details-row">
                    <span className="mobile-details-label">{label} :</span>
                    <span className="mobile-details-val">{value}</span>
                  </div>
                ))}
              </div> */}

              {/* Carbon footprint + lifespan (same as desktop stat boxes) */}
              <div className="mobile-kpi-grid">
                <div className="mobile-kpi-card">
                  <span className="mobile-kpi-label">Carbon Footprint</span>
                  <span className="mobile-kpi-val">{pd.carbonFootprint ?? "-"} kg CO₂</span>
                </div>
                <div className="mobile-kpi-card">
                  <span className="mobile-kpi-label">Lifespan</span>
                  <span className="mobile-kpi-val">{pd.expectedLifespan ?? "-"} years</span>
                </div>
              </div>

              {/* Materials */}
              <div className="mobile-material-card">
                <strong style={{ color: "#334155" }}>Materials :</strong>
                {mainData?.mainCard?.rawMaterials?.length > 0 ? (
                  mainData.mainCard.rawMaterials.map((m, i) => (
                    <span key={i} className="mobile-material-chip">{m}</span>
                  ))
                ) : (
                  <span>—</span>
                )}
              </div>

              {/* Tests */}
              <div className="mobile-material-card">
                <strong style={{ color: "#334155" }}>Tests :</strong>
                {mainData?.testingTypes?.length > 0 ? (
                  mainData.testingTypes.map((m, i) => (
                    <span key={i} className="mobile-material-chip">{m}</span>
                  ))
                ) : (
                  <span>—</span>
                )}
              </div>
            </>
          );
        })()}






      </div>
      <div style={{ width: "100%", borderTop: "1px dashed #cbd5e1", paddingTop: "16px" }}>
        <div style={{ fontSize: "13px", fontWeight: "700", color: "#0f172a", marginBottom: "12px", textAlign: "center" }}>
          Environmental Impact
        </div>

        {/* 2x2 Grid setup with Inline Styles for Perfect Layout */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "10px" }}>

          {/* CO2 Footprint */}
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "12px", background: "#ffffff", padding: "10px 12px", borderRadius: "10px", border: "1px solid #e2e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.02)" }}>
            <div style={{ width: "36px", height: "36px", flexShrink: 0, background: "#dcfce7", color: "#16a34a", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
                <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                <path d="M9 9h.01M15 9h.01" />
              </svg>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", overflow: "hidden" }}>
              <span style={{ fontSize: "10px", color: "#64748b", fontWeight: 700, textTransform: "uppercase", lineHeight: 1, marginBottom: "4px" }}>CO₂</span>
              <span style={{ fontSize: "13px", fontWeight: 800, color: "#0f172a", lineHeight: 1.2, whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100%" }}>
                {co2Value} {co2Value !== "—" && <span style={{ fontSize: "10px" }}>kg</span>}
              </span>
            </div>
          </div>

          {/* Energy Usage */}
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "12px", background: "#ffffff", padding: "10px 12px", borderRadius: "10px", border: "1px solid #e2e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.02)" }}>
            <div style={{ width: "36px", height: "36px", flexShrink: 0, background: "#fef3c7", color: "#d97706", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
              </svg>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", overflow: "hidden" }}>
              <span style={{ fontSize: "10px", color: "#64748b", fontWeight: 700, textTransform: "uppercase", lineHeight: 1, marginBottom: "4px" }}>Energy</span>
              <span style={{ fontSize: "13px", fontWeight: 800, color: "#0f172a", lineHeight: 1.2, whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100%" }}>
                {energyValue} {energyValue !== "—" && <span style={{ fontSize: "10px" }}>kWh</span>}
              </span>
            </div>
          </div>

          {/* Water Usage */}
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "12px", background: "#ffffff", padding: "10px 12px", borderRadius: "10px", border: "1px solid #e2e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.02)" }}>
            <div style={{ width: "36px", height: "36px", flexShrink: 0, background: "#dbeafe", color: "#2563eb", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z" />
              </svg>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", overflow: "hidden" }}>
              <span style={{ fontSize: "10px", color: "#64748b", fontWeight: 700, textTransform: "uppercase", lineHeight: 1, marginBottom: "4px" }}>Water</span>
              <span style={{ fontSize: "13px", fontWeight: 800, color: "#0f172a", lineHeight: 1.2, whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100%" }}>
                {waterValue} {waterValue !== "—" && <span style={{ fontSize: "10px" }}>L</span>}
              </span>
            </div>
          </div>

          {/* Recyclability */}
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "12px", background: "#ffffff", padding: "10px 12px", borderRadius: "10px", border: "1px solid #e2e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.02)" }}>
            <div style={{ width: "36px", height: "36px", flexShrink: 0, background: "#f3e8ff", color: "#9333ea", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: "20px", lineHeight: 1, marginTop: "-2px" }}>♻</span>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", overflow: "hidden" }}>
              <span style={{ fontSize: "10px", color: "#64748b", fontWeight: 700, textTransform: "uppercase", lineHeight: 1, marginBottom: "4px" }}>Recycle</span>
              <span style={{ fontSize: "13px", fontWeight: 800, color: "#0f172a", lineHeight: 1.2, whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100%" }}>
                {recyclabilityValue} {recyclabilityValue !== "—" && <span style={{ fontSize: "10px" }}>%</span>}
              </span>
            </div>
          </div>

        </div>
      </div>

      {treeMapData && Object.keys(treeMapData).length > 0 && (
        <div className="mobile-impact-box" style={{ alignItems: "stretch" }}>
          <div className="mobile-impact-title" style={{ textAlign: "center" }}>DPP Hierarchy Structure</div>
          <HierarchyNode
            node={treeMapData}
            isRoot={true}
            handleRedirect={roleId ? handleTreeRedirect : null}
          />
        </div>
      )}

      {roleId && (<div className="mobile-lifecycle-container">
        <div className="mobile-lifecycle-header">Product Lifecycle Journey</div>

        <div className="mobile-tabs-scroll" ref={tabsRef} onScroll={updateTabsThumb}>
          {journeySteps.map((step) => {
            if (!step.view) return null;
            const stageData = mainData?.productLifecycleJourney?.[step.key];
            const orderNumber = stageData?.orderNumber;
            const isAvailable = !(!orderNumber || orderNumber === "n/a" || orderNumber === "");
            return (
              <button
                key={step.key}
                className={`mobile-tab-btn ${selectedJourneyKey === step.key ? "active" : ""} ${isAvailable ? "" : "unavailable"}`}
                onClick={() => openJourneyStep(step)}
              >
                {stageData?.name || step.key}
              </button>
            );
          })}
        </div>

        {/* scroll indicator: thumb width = visible stages / total stages */}
        <div className="mobile-tabs-track">
          <div
            className="mobile-tabs-thumb"
            style={{ width: `${tabsThumb.width}%`, left: `${tabsThumb.left}%` }}
          />
        </div>

        {loading && (
          <div style={{ padding: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress size={30} />
          </div>
        )}

        {!loading && selectedJourneyKey && (
          <div className="mobile-stage-content">

            {/* <div className="mobile-stage-title">
              {moduleName || mainData?.productLifecycleJourney?.[selectedJourneyKey]?.name || ""}
            </div> */}

            {/* KPI GRID (same visibility rules as the desktop sidebar) */}
            {(() => {
              const h = mobileActiveStep?.mainHeader || {};
              const isMfg = moduleName === "Manufacturing";
              const isEnv = moduleName === "Environmental Impact & Sustainability";
              const showImpact = isMfg || isEnv;
              const tiles = [
                h.plant && ["Location", h.location || "—"],
                ["Company Name", h.companyName || "—"],
                h.productionDate && [
                  moduleName === "Manufacturing"
                    ? "Date of Manufacturing"
                    : moduleName === "Raw Material"
                      ? "PO Date"
                      : "Manufacturing Date",
                  h.productionDate,
                ],
                hasIndustryId && [
                  moduleName === "Raw Material" ? "Blend Ratio" : "Plant",
                  moduleName === "Raw Material" ? h.blendRatio || "—" : h.plant || "—",
                ],
                showImpact && ["Energy Usage", `${formatFloat(h.energyUsage || h.electricityConsumption)} kWh`],
                showImpact && ["Water Usage", `${formatFloat(h.waterUsage || h.waterConsumption)} liters`],
                showImpact && ["Carbon Footprint", `${formatFloat(h.carbonFootprint)} kg CO₂`],
                h.recyclabilityScore && ["Recyclability", `${formatFloat(h.recyclabilityScore)} %`],
              ].filter(Boolean);

              return (
                <div className="mobile-kpi-grid">
                  {tiles.map(([label, value]) => (
                    <div key={label} className="mobile-kpi-card">
                      <span className="mobile-kpi-label">{label}</span>
                      <span className="mobile-kpi-val">{value}</span>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* MATERIALS USED */}
            {isRawMaterialModule ? (
              uniqueRmItems.length > 0 && (
                <div className="mobile-material-card">
                  <strong style={{ color: "#334155" }}>Materials Used :</strong>
                  {uniqueRmItems.map((m, idx) => (
                    <span
                      key={idx}
                      className="mobile-material-chip clickable"
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        setSelectedMaterialData(m);
                        setOpenMaterialModal(true);
                      }}
                    >
                      {m.rmItemCode}
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    </span>
                  ))}
                </div>
              )
            ) : (
              mobileActiveStep?.materialsUsed?.length > 0 && (
                <div className="mobile-material-card">
                  <strong style={{ color: "#334155" }}>Materials Used :</strong>
                  {mobileActiveStep.materialsUsed.map((m, idx) => (
                    <span key={idx} className="mobile-material-chip">{m}</span>
                  ))}
                </div>
              )
            )}

            {/* OPERATIONS */}
            {opsData?.length > 0 && (
              <div className="mobile-accordion">
                <div className="mobile-accordion-header" onClick={() => toggleSection("operations")}>
                  <span>Operations</span>
                  {openSections.operations ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
                {openSections.operations && (
                  <div className="mobile-accordion-body">
                    <OperationsTimeline operationsData={opsData} />
                  </div>
                )}
              </div>
            )}

            {/* DETAILED INFORMATION */}
            {showDetailedInfo && rowsHaveData(detailRows) && (
              <div className="mobile-accordion">
                <div className="mobile-accordion-header" onClick={() => toggleSection("detailedInfo")}>
                  <span>Detailed Information</span>
                  {openSections.detailedInfo ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
                {openSections.detailedInfo && (
                  <div className="mobile-accordion-body">
                    <div className="mobile-info-rows">
                      {detailRows.map(([label, value], i) => (
                        <div key={i} className="mobile-info-row">
                          <span className="mobile-info-key">{label}</span>
                          <span className="mobile-info-val">{value}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* CARE AND USE INSTRUCTIONS */}
            {showCareInstructions && rowsHaveData(careRows) && (
              <div className="mobile-accordion">
                <div className="mobile-accordion-header" onClick={() => toggleSection("careInstructions")}>
                  <span>Care And Use Instructions</span>
                  {openSections.careInstructions ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
                {openSections.careInstructions && (
                  <div className="mobile-accordion-body">
                    <div className="mobile-info-rows">
                      {careRows.map(([label, value], i) => (
                        <div key={i} className="mobile-info-row">
                          <span className="mobile-info-key">{label}</span>
                          <span className="mobile-info-val">{value}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* PRODUCT TEST TYPES + CHEMICAL ANALYSIS */}
            {moduleName === "Product Tests" && hasProductTestData && (
              <div className="mobile-accordion">
                <div className="mobile-accordion-header" onClick={() => toggleSection("productTestTypes")}>
                  <span>Product Test Types</span>
                  {openSections.productTestTypes ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
                {openSections.productTestTypes && (
                  <div className="mobile-accordion-body">
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {hasIndustryId ? (
                        <span
                          className="mobile-material-chip clickable"
                          onClick={() => openTestModal(mobileActiveStep?.textileTest, "textileTest")}
                        >
                          Textile Test
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </span>
                      ) : hasBatteryIndustry ? (
                        <>
                          <span
                            className="mobile-material-chip clickable"
                            onClick={() => openTestModal(mobileActiveStep?.thermalStabilityTest, "thermalStability")}
                          >
                            Thermal Stability Test
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                          </span>
                          <span
                            className="mobile-material-chip clickable"
                            onClick={() => openTestModal(mobileActiveStep?.shortCircuitOverchargeTest, "shortCircuitOverchargeTest")}
                          >
                            Short Circuit & Overcharge Test
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                          </span>
                        </>
                      ) : (
                        <>
                          <span
                            className="mobile-material-chip clickable"
                            onClick={() => openTestModal(mobileActiveStep?.notchimpactTest, "notchimpactTest")}
                          >
                            Notch Impact Test
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                          </span>
                          <span
                            className="mobile-material-chip clickable"
                            onClick={() => openTestModal(mobileActiveStep?.tensileTest, "tensileTest")}
                          >
                            Tensile Test
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                          </span>
                          <span
                            className="mobile-material-chip clickable"
                            onClick={() => openTestModal(mobileActiveStep?.hardnessTest, "hardnessTest")}
                          >
                            Hardness Test
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {moduleName === "Product Tests" && !hasIndustryId && !hasBatteryIndustry && rowsHaveData(chemRows) && (
              <div className="mobile-accordion">
                <div className="mobile-accordion-header" onClick={() => toggleSection("chemicalAnalysis")}>
                  <span>Chemical Analysis</span>
                  {openSections.chemicalAnalysis ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
                {openSections.chemicalAnalysis && (
                  <div className="mobile-accordion-body">
                    <div className="mobile-info-rows">
                      {chemRows.map(([label, value], i) => (
                        <div key={i} className="mobile-info-row">
                          <span className="mobile-info-key">{label}</span>
                          <span className="mobile-info-val">{value ?? "—"}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* RAW MATERIALS DETAILS */}
            {mobileActiveStep?.rawMaterialsDetails?.length > 0 && (
              <div className="mobile-accordion">
                <div className="mobile-accordion-header" onClick={() => toggleSection("rawMaterialsDetails")}>
                  <span>Raw Materials Details</span>
                  {openSections.rawMaterialsDetails ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
                {openSections.rawMaterialsDetails && (
                  <div className="mobile-accordion-body">
                    {mobileActiveStep.rawMaterialsDetails.map((material, i) => (
                      <div
                        key={i}
                        className="mobile-rm-card"
                        style={{ cursor: isRawMaterialModule ? "pointer" : "default" }}
                        onClick={() => {
                          if (isRawMaterialModule) {
                            setSelectedMaterialData(material);
                            setOpenMaterialModal(true);
                          }
                        }}
                      >
                        <div style={{ fontWeight: 600, color: "#0f172a", marginBottom: 6, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <span>{material.rmItemCode}</span>
                          {isRawMaterialModule && <ExpandMoreIcon style={{ transform: "rotate(-90deg)", color: "#1d4ed8" }} />}
                        </div>
                        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
                          Vendor: {material.vendorName} • Quantity: {material.quantity}
                        </div>
                        <div style={{ fontSize: 12, color: "#6b7280" }}>
                          PO: {material.poNumber} • GRN: {material.grnNumber}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* JOURNEY TIMELINE */}
            {mobileActiveStep?.journeyTimeline?.length > 0 && (
              <div className="mobile-accordion">
                <div className="mobile-accordion-header" onClick={() => toggleSection("journeyTimeline")}>
                  <span>Journey Timeline</span>
                  {openSections.journeyTimeline ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
                {openSections.journeyTimeline && (
                  <div className="mobile-accordion-body">
                    <JourneyTimeline journeyTimelineData={mobileActiveStep.journeyTimeline} />
                  </div>
                )}
              </div>
            )}

            {/* REPAIR / RECYCLE INFO */}
            {mobileActiveStep?.repairRecyclingInfo && (
              <div className="mobile-accordion">
                <div className="mobile-accordion-header" onClick={() => toggleSection("repairRecycle")}>
                  <span>Repair & Recycle Info</span>
                  {openSections.repairRecycle ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
                {openSections.repairRecycle && (
                  <div className="mobile-accordion-body">
                    <RepairRecycleModal repairRecyclingInfo={mobileActiveStep.repairRecyclingInfo} />
                  </div>
                )}
              </div>
            )}

            {/* DIVIDER before certificates / documents (centered: line | label | line) */}
            {/* {(certGroups.length > 0 || documentsList.length > 0) && (
              <div
                className="mobile-resources-divider"
                role="separator"
                style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "100%", gap: 10 }}
              >
                <span className="mobile-resources-divider-line" style={{ flex: "1 1 0", height: 1, background: "#cbd5e1" }} />
                <span className="mobile-resources-divider-label">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M20 6L9 17l-5-5" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Certificates & Documents
                </span>
                <span className="mobile-resources-divider-line" style={{ flex: "1 1 0", height: 1, background: "#cbd5e1" }} />
              </div>
            )} */}


          </div>
        )}



      </div>)}

      {/* CERTIFICATES SECTION */}
      {certGroups.length > 0 && (
        <div className="mobile-certdoc-section">
          <div className="mobile-certdoc-title">Certificates</div>

          <div className="mobile-certdoc-card">
            {certGroups.map((group) => (
              <div key={group.title} className="mobile-certdoc-group">
                <div className="mobile-certdoc-heading">{group.title}</div>
                <div className="mobile-certdoc-chips">
                  {group.items.map((name, i) => (
                    <div key={i} className="mobile-certdoc-chip">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6L9 17l-5-5" stroke="#0f172a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span>{name}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* DOCUMENTS SECTION */}
      {(documentsList.length > 0 && roleId && viewValidation) && (
        <div className="mobile-certdoc-section docs">
          <div className="mobile-certdoc-title">Documents</div>

          <div className="mobile-certdoc-card">
            <div className="mobile-certdoc-heading">Available Documents</div>
            <div className="mobile-certdoc-chips">
              {documentsList.map((doc, idx) => (
                <div
                  key={idx}
                  className="mobile-certdoc-doc"
                  onClick={() => handleDocumentClick(doc)}
                >
                  <TextSnippetIcon style={{ fill: "#ea580c", fontSize: 20 }} />
                  <span className="mobile-certdoc-doc-name">{doc?.name}</span>
                  <OpenInNewIcon style={{ fontSize: 16, color: "#0f172a", flexShrink: 0 }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {!roleId && (
        <div style={{ width: "100%", padding: "0 16px", marginBottom: "16px", boxSizing: "border-box" }}>
          <MDButton
            color="info"
            variant="outlined"
            fullWidth
            onClick={handleViewMoreInfo}
            sx={{
              padding: "12px 16px",
              fontSize: "14px",
              minHeight: "44px",
              textTransform: "none",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              borderRadius: "8px",
            }}
          >
            {/* Lock Icon */}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>

            View More Detail
          </MDButton>
        </div>
      )}


      {/* FOOTER */}
      <div className="mobile-dev-footer">
        Developed and maintained by : <strong>Mobillor Technologies Pvt. Ltd.</strong>
      </div>



      <Dialog open={openMaterialModal} onClose={() => setOpenMaterialModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Raw Material Details</span>
          {selectedMaterialData?.dppUrl && (
            <MDButton
              color="info"
              variant="outlined"
              size="small"
              onClick={() => {
                let url = selectedMaterialData.dppUrl;
                if (!/^https?:\/\//i.test(url)) {
                  url = 'http://' + url;
                }
                window.open(url, "_blank", "noopener,noreferrer");
              }}
              sx={{
                padding: "4px 10px",
                fontSize: "11px",
                minHeight: "28px",
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: "4px"
              }}
            >
              View DPP
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </MDButton>
          )}
        </DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>

            {selectedMaterialData?.dppCode && (
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>DPP Code</div>
                <div
                  onClick={() => handleViewClick(selectedMaterialData?.dppCode)}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "6px 14px",
                    background: "#eff6ff",
                    color: "#2563eb",
                    border: "1px solid #bfdbfe",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: 700,
                    cursor: "pointer",
                    textDecoration: "underline",
                    textUnderlineOffset: "3px",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#dbeafe";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#eff6ff";
                  }}
                >
                  {selectedMaterialData?.dppCode}
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="M9 18l6-6-6-6"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            )}

            {[
              ["Item Code", selectedMaterialData?.rmItemCode],
              ["Quantity", selectedMaterialData?.quantity],
              ["Batch/Serial Number", selectedMaterialData?.batch_serialNumber],
              ["Vendor Name", selectedMaterialData?.vendorName],
              ["Supplier Audits", selectedMaterialData?.supplierAudits],
              ["Traceability", selectedMaterialData?.traceability],
              ["Ethical Score", selectedMaterialData?.ethicalScore],
              ["Source Mapping", selectedMaterialData?.sourceMapping],
              ["Material Purity", selectedMaterialData?.materialPurity],
              ["PO Number", selectedMaterialData?.poNumber],
              ["Country Of Origin", selectedMaterialData?.countryOfOrigin],
              ["Recycled Material", selectedMaterialData?.recycledMaterial ? `${selectedMaterialData.recycledMaterial} %` : null],
              ...(hasIndustryId
                ? [
                  ["Bio Based Material", selectedMaterialData?.bioBasedMaterial ? `${selectedMaterialData.bioBasedMaterial} %` : null],
                  ["Organic Cotton", selectedMaterialData?.organicCotton ? `${selectedMaterialData.organicCotton} %` : null],
                ]
                : []),
              ...(hasBatteryIndustry ? [["Mine Name", selectedMaterialData?.mineName], ["Mine Country", selectedMaterialData?.mineCountry], ["Refinery Name", selectedMaterialData?.refineryName], ["Refinery Country", selectedMaterialData?.refineryCountry]] : []),
              ["PO Date", selectedMaterialData?.poDate ? new Date(selectedMaterialData.poDate).toLocaleDateString("en-CA").replace(/-/g, "/") : null],
              ["GRN Number", selectedMaterialData?.grnNumber],
              [
                "GRN Date",
                selectedMaterialData?.grnDate
                  ? (() => {
                    const date = new Date(selectedMaterialData.grnDate);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");
                    return `${year}/${month}/${day}`;
                  })()
                  : null,
              ],
            ].map(([label, value], i) => {
              if (value === null || value === undefined) return null;
              return (
                <div key={i} style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>{label}</div>
                  <div style={{ fontWeight: 700, color: "#0f172a" }}>{value || "—"}</div>
                </div>
              );
            })}
          </div>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpenMaterialModal(false)} color="info" variant="contained" sx={{ display: "block", margin: "0 auto" }}>
            Close
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* TEST DETAILS MODAL */}
      <Dialog open={openViewItemsModal} onClose={() => setOpenViewItemsModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{testModalTitle}</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>
            {testType === "thermalStability" &&
              thermalFields.map(([label, key, fmt], i) => {
                const value = viewItemsData?.[key];
                if (value === undefined || value === null || value === "") return null;
                return (
                  <div key={`thermal-${i}`} style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>{label}</div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>{fmt(value)}</div>
                  </div>
                );
              })}

            {testModalFields.map(([label, key, fmt], i) => {
              const value = viewItemsData?.[key];
              const isDefinedField = key === "hardnessMean" || key === "hardnessIndividualValues";
              const present = isDefinedField ? value !== undefined : value !== undefined && value !== null && value !== "";
              if (!present) return null;
              return (
                <div key={i} style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>{label}</div>
                  <div style={{ fontWeight: 700, color: "#0f172a" }}>{isDefinedField ? value : fmt(value)}</div>
                </div>
              );
            })}
          </div>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpenViewItemsModal(false)} color="info" variant="contained" sx={{ display: "block", margin: "0 auto" }}>
            Close11
          </MDButton>
        </DialogActions>
      </Dialog>

      <QRCodeModal
        showQR={showQR}
        onClose={() => setShowQR(false)}
        encodedPath={encodedPath}
        MiniLogo={MiniLogo}
        dppCode={dppCode}
      />


    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getAllDataForDpp: (dppCode, jwtToken) =>
      dispatch(getAllDataForDpp(dppCode, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DppMobileView);
